import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список новостей
 */
export const selectNewsList = ({ newsList }: IApplicationState) => newsList;
